export const TOGGLE_LOADING = 'src/routes/DevicesPage/TOGGLE_LOADING'
export const UPDATE_DATA = 'src/routes/DevicesPage/UPDATE_DATA'
export const REQUEST_DATA = 'src/routes/DevicesPage/REQUEST_DATA'
export const SET_EXPANDED_GROUP = 'src/routes/DevicesPage/SET_EXPANDED_GROUP'
export const REQUEST_DEVICE_PROPERTIES =
  'src/routes/DevicesPage/REQUEST_DEVICE_PROPERTIES'
export const UPDATE_DEVICE_PROPERTIES =
  'src/routes/DevicesPage/UPDATE_DEVICE_PROPERTIES'
export const REQUEST_USER_GROUP = 'src/routes/DevicesPage/REQUEST_USER_GROUP'
export const UPDATE_USER_GROUP = 'src/routes/DevicesPage/UPDATE_USER_GROUP'
export const UPDATE_FILTERER = 'src/routes/DevicesPage/UPDATE_FILTERER'
export const SELECT_DEVICE = 'src/routes/DevicesPage/SELECT_DEVICE'
export const CLEAR_DEVICE = 'src/routes/DevicesPage/CLEAR_DEVICE'
export const REQUEST_DOWNLOAD_EXCEL =
  'src/routes/DevicesPage/REQUEST_DOWNLOAD_EXCEL'
export const CLOSE_DOWNLOAD_EXCEL =
  'src/routes/DevicesPage/CLOSE_DOWNLOAD_EXCEL'
export const GET_DATA_DOWNLOAD = 'src/routes/DevicesPage/GET_DATA_DOWNLOAD'
export const SHOW_DATA_DOWNLOAD_FAILED =
  'src/routes/DevicesPage/SHOW_DATA_DOWNLOAD_FAILED'
export const UPDATE_DOWNLOAD_PROGRESS =
  'src/routes/DevicesPage/UPDATE_DOWNLOAD_PROGRESS'
export const RESUME_DOWNLOAD_PROGRESS =
  'src/routes/DevicesPage/RESUME_DOWNLOAD_PROGRESS'
export const FINISH_DOWNLOAD = 'src/routes/DevicesPage/FINISH_DOWNLOAD'
export const REQUEST_CLOSE_DOWNLOAD_EXCEL =
  'src/routes/DevicesPage/REQUEST_CLOSE_DOWNLOAD_EXCEL'
export const REQUEST_CHILDREN_OF_USER =
  'src/routes/DevicesPage/REQUEST_CHILDREN_OF_USER'
export const UPDATE_CHIDREN_OF_USER =
  'src/routes/DevicesPage/UPDATE_CHIDREN_OF_USER'
export const UPDATE_PROPERTY_CHILDREN_USER =
  'src/routes/DevicesPage/UPDATE_PROPERTY_CHILDREN_USER'

export const requestData = (
  pageSize,
  page,
  sorted,
  filtered,
  isGetRelationDevice = false
) => ({
  type: REQUEST_DATA,
  pageSize,
  page,
  sorted,
  filtered,
  isGetRelationDevice
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updateData = (data, pages, total) => ({
  type: UPDATE_DATA,
  data,
  pages,
  total
})

export const setExpandGroup = newExpander => ({
  type: SET_EXPANDED_GROUP,
  newExpander
})

export const requestDeviceProperties = () => ({
  type: REQUEST_DEVICE_PROPERTIES
})

export const updateDeviceProperties = deviceProperties => ({
  type: UPDATE_DEVICE_PROPERTIES,
  deviceProperties
})

export const requestUserGroup = (isGetTotal, isAdmin) => ({
  type: REQUEST_USER_GROUP,
  isGetTotal,
  isAdmin
})

export const requestChildrenOfUser = (parentId, toggled) => ({
  type: REQUEST_CHILDREN_OF_USER,
  parentId,
  toggled
})

export const updateUserGroup = users => ({
  type: UPDATE_USER_GROUP,
  users
})

export const updateChildrenOfUser = (parentId, children) => ({
  type: UPDATE_CHIDREN_OF_USER,
  children,
  parentId
})

export const updatePropertyChildrenUser = (parentId, key, value) => ({
  type: UPDATE_PROPERTY_CHILDREN_USER,
  parentId,
  key,
  value
})

export const updateFilter = filter => ({
  type: UPDATE_FILTERER,
  filter
})

export const selectDevice = device => ({
  type: SELECT_DEVICE,
  device
})

export const clearDeviceSelected = () => ({
  type: CLEAR_DEVICE
})

export const requestDownloadExcel = (total, filtered, all) => ({
  type: REQUEST_DOWNLOAD_EXCEL,
  filtered,
  total,
  all
})

export const closeDownloadExcel = () => ({
  type: CLOSE_DOWNLOAD_EXCEL
})

export const getDataDownload = () => ({
  type: GET_DATA_DOWNLOAD
})

export const showDataDownloadFailed = error => ({
  type: SHOW_DATA_DOWNLOAD_FAILED,
  error
})

export const updateDataProgress = (data, limit, page, total, filtered, all) => ({
  type: UPDATE_DOWNLOAD_PROGRESS,
  data,
  limit,
  page,
  total,
  filtered,
  all
})

export const resumeDownload = () => ({
  type: RESUME_DOWNLOAD_PROGRESS
})

export const finishDownload = () => ({
  type: FINISH_DOWNLOAD
})

export const requestCloseDownload = () => ({
  type: REQUEST_CLOSE_DOWNLOAD_EXCEL
})
